import produce from 'immer';
import { Actions } from './action';
import { AppAction } from './enum';
import { AppState } from './interface';
import {
    handleSetAvailability,
    handleSetSelectedTariffId,
    handleSetAvailableTariffs,
} from './util/reducer.util';

export const initialState: AppState = {
    loadingStatus: {},
    isFriendsAndFamily: false,
    isGigakombi: false,
    isTVProductSelected: false,
    isYoung: false,
    availableTariffs: [],
    initialTariffs: [],
    selectedTariffId: 'kip-1000-cablemax-bv',
    isLoggedIn: false,
};

const appReducer = (state: AppState = initialState, action: Actions) =>
    produce(state, draft => {
        switch (action.type) {
            case AppAction.START_LOADING:
                draft.loadingStatus[action.id] = true;
                break;
            case AppAction.STOP_LOADING:
                delete draft.loadingStatus[action.id];
                break;
            case AppAction.INIT_STORE:
                draft.selectedTariffId = action.state.selectedTariffId ?? draft.selectedTariffId;
                draft.isGigakombi = action.state.isGigakombi ?? draft.isGigakombi;
                draft.isFriendsAndFamily = action.state.isFriendsAndFamily ?? draft.isFriendsAndFamily;
                draft.isTVProductSelected = action.state.isTVProductSelected ?? draft.isTVProductSelected;
                draft.isYoung = action.state.isYoung ?? draft.isYoung;
                draft.selectedTVProduct = action.state.selectedTVProduct;
                draft.availableTariffs = action.state.availableTariffs ?? [];
                draft.address = action.state.address ?? draft.address;
                draft.customer = action.state.customer;
                draft.alternativeTariff = action.state.alternativeTariff;
                draft.marketability = action.state.marketability;
                draft.bannerId = action.state.bannerId;
                draft.availability = action.state.availability;
                break;
            case AppAction.SET_ERROR:
                draft.error = action.error;
                break;
            case AppAction.RESET_STATE:
            case AppAction.DELETE_ADDRESS:
                draft.address = undefined;
                draft.alternativeTariff = undefined;
                draft.isTVProductSelected = false;
                draft.selectedTVProduct = undefined;
                draft.marketability = undefined;
                draft.availability = undefined;
                draft.preSelectedTariff = draft.initialTariffs.find(tariff => tariff.download === draft.preSelectedTariff?.download);
                handleSetAvailableTariffs(draft, draft.initialTariffs, draft.preSelectedTariff?.id);
                break;
            case AppAction.SET_INITIAL_TARIFFS:
                draft.initialTariffs = action.tariffs;
                !draft.address && handleSetAvailableTariffs(draft, action.tariffs);
                draft.preSelectedTariff = draft.availableTariffs.find(tariff => tariff.id === draft.selectedTariffId);
                break;
            case AppAction.SET_SELECTED_TARIFF_ID:
                draft.preSelectedTariff = draft.availableTariffs.find(tariff => tariff.id === action.selectedTariffId);
                handleSetSelectedTariffId(draft, action.selectedTariffId);
                break;
            case AppAction.SET_TV_PRODUCT_SELECTION:
                draft.isTVProductSelected = action.isTVProductSelected;
                break;
            case AppAction.SET_FRIENDS_AND_FAMILY:
                draft.isFriendsAndFamily = action.isFriendsAndFamily;
                break;
            case AppAction.SET_GIGAKOMBI:
                draft.isGigakombi = action.isGigakombi;
                break;
            case AppAction.SET_YOUNG:
                draft.isYoung = action.isYoung;
                break;
            case AppAction.SET_AVAILABILITY:
                handleSetAvailability(draft, action.availabilityResponse, action.availability, action.alternativeTariff);
                break;
            case AppAction.SET_CUSTOMER:
                draft.customer = action.customer;
                draft.address = action.address;
                break;
            case AppAction.SET_LOGIN_STATUS:
                draft.isLoggedIn = true;
                draft.customerType = action.customerType;
                break;
            case AppAction.SET_BANNER_ID:
                draft.bannerId = action.id;
                break;
        }
    });

export default appReducer;
